import { render, staticRenderFns } from "./BagsOrWalletsComponent.vue?vue&type=template&id=b02c3e88&"
import script from "./BagsOrWalletsComponent.vue?vue&type=script&lang=js&"
export * from "./BagsOrWalletsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports